import { DEFAULT_BLACK_IMAGE_PATH } from '../../scripts/Routes/images.js';

export const shows = {
  '2024': [
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': '49ers vs Rams ',
      'location': 'Levi Stadium',
      'url': '#',
    },
  ],
  '2023': [
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': '49ers vs Seahawks (NFC Wild Card)',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'Gear Show @ Non-Verbal Theater in Kyoto ',
      'url': '#',
    },
  ],
  '2022': [
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'Comedy Cellar (Village Underground) w/ Jeff Ross & Godfrey',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'Comedy Cellar (Macdougal) w/ Chris Rock',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'Hasan Minhaj: Kings Jester',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'Bill Burr in San Jose',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'John Mayer: Sob Rock',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'Nimesh Patel @ SJ Improv',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'Justin Bieber: Justice @ SJ SAP center',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'Ronny Chieng: Hope you get Rich @ SJ Civic Center',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'Dave Chappelle: Untitled Documentary @ SF Chase Center',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'Aziz Ansari: Last Minute Tour @ Oakland Fox Theater',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'Top Secret Comedy Club (London)',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'Khruangbin at Greek Theatre',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'Coldplay Concert @ Wembley Stadium',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'Flamenco @ a Gypsy cave in Granada, Spain',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': '2nd comedy show ever in Prague',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'Kokoroko in Utrecht, Netherlands',
      'url': '#',
    },
  ],
};
